import React from 'react';
import PropTypes from 'prop-types';
import {assetUrl} from '../../../../utils/cdnUtils';


function CountryFlag({countryAlpha2}) {

    // add inline bundling later
    return (
        <img
            alt={countryAlpha2}
            src={assetUrl(`/images/icons/countries/${countryAlpha2}.svg`)}
        />
    );
}


CountryFlag.propTypes = {
    countryAlpha2: PropTypes.string.isRequired
};

CountryFlag.defaultProps = {};


export default CountryFlag;
